window.addEventListener('load', function() {

  // Get Modal
  var alertModal = $('#popup');
  if(!alertModal.length)
    return;

  // Launch Modal after delay
  var delay = alertModal.data('delay') * 1000;
  setTimeout(function(){
    alertModal.foundation('open');

  }, delay);

});
